import { render, staticRenderFns } from "./group-tags-template.vue?vue&type=template&id=518dd096&scoped=true&"
import script from "./group-tags-template.vue?vue&type=script&lang=js&"
export * from "./group-tags-template.vue?vue&type=script&lang=js&"
import style0 from "./group-tags-template.vue?vue&type=style&index=0&id=518dd096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518dd096",
  null
  
)

export default component.exports